"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.geoExtractorConfig = void 0;
exports.geoExtractorConfig = {
    name: 'geoextractor',
    fullname: 'Geological Extractor',
    description: 'Extracts stone from the ground using a powerful ray.',
    type: 'mining',
    width: 1,
    height: 1,
    levelMax: 8,
    canBeDisabled: true,
    requiredTechnology: 'stone',
    levels: [
        { level: 0, constructionCosts: {}, time: 40, provides: { stone: 1 }, costs: { energy: 1 }, stores: {} },
        { level: 1, constructionCosts: { stone: 10, energy: 100 }, time: 30, provides: { stone: 1 }, costs: { energy: 1 }, stores: {} },
        { level: 2, constructionCosts: { stone: 10, energy: 100, iron: 10 }, time: 20, provides: { stone: 1 }, costs: { energy: 1 }, stores: {} },
        { level: 3, constructionCosts: { stone: 10, energy: 300, iron: 30 }, time: 20, provides: { stone: 2 }, costs: { energy: 1 }, stores: {} },
        { level: 4, constructionCosts: { stone: 10, energy: 500, iron: 50 }, time: 10, provides: { stone: 3 }, costs: { energy: 1 }, stores: {} },
        { level: 5, constructionCosts: { stone: 30, energy: 1000, iron: 100 }, time: 8, provides: { stone: 5 }, costs: { energy: 1 }, stores: {} },
        { level: 6, constructionCosts: { stone: 50, energy: 2000, iron: 1000, gold: 10 }, time: 6, provides: { stone: 8 }, costs: { energy: 1 }, stores: {} },
        { level: 7, constructionCosts: { stone: 200, energy: 3000, iron: 3000, gold: 100 }, time: 4, provides: { stone: 8 }, costs: { energy: 1 }, stores: {} },
        { level: 8, constructionCosts: { stone: 500, energy: 4000, iron: 3000, gold: 200 }, time: 1, provides: { stone: 10 }, costs: { energy: 1 }, stores: {} },
    ],
};



//////////////////
// WEBPACK FOOTER
// ../engine/dist/config/buildings/geoextractor.js
// module id = yya+
// module chunks = 0